import { GreetingMessage } from 'cpie-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-15/frontend-integration';
import { fetchGreeting } from './GreetingSlice';
import { GreetingDataSelector } from './GreetingDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

export function useGreeting(): AbstractDataState<GreetingMessage, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchGreeting, GreetingDataSelector);
}
